import { TableCard } from '../../../../components'
import { AtendimentoGestaoListHeader } from './components/header/AtendimentoGestaoListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { AtendimentoGestaoTable } from './table/AtendimentoGestaoTable'

const AtendimentoGestaoList = () => {
  return (
    <TableCard>
      <AtendimentoGestaoListHeader />
      <AtendimentoGestaoTable />
    </TableCard>
  )
}

export const AtendimentoGestaoListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <AtendimentoGestaoList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
